export default () => {
  if (window.origin.includes("umstudio") || window.origin.includes("localhost")) {
    return "https://david.umstudio.com.br/api/v1/";
  }

  return "https://www.davidtheagency.com/api/v1/";
};
